var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.model.scanning.scanningStatus != null)?_c('cv-inline-loading',{attrs:{"ending-text":"Scan ended","error-text":_vm.model.scanning.scanningStatusMessage,"loading-text":_vm.model.scanning.scanningStatusMessage,"loaded-text":"Scan finished","state":_vm.model.scanning.scanningStatus}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }